import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';
import { isUndefined } from 'lodash';

export const passwordResetApi = createApi({
  reducerPath: 'passwordResetApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    validateToken: builder.mutation({
      query(token) {
        return {
          url: urls.validateToken,
          method: 'POST',
          data: { token },
        };
      },
    }),
    resetPassword: builder.mutation({
      query(values) {
        return {
          url: urls.passwordReset,
          method: 'POST',
          data: values,
        };
      },
    }),
    resetPasswordSubmit: builder.mutation({
      query(values) {
        return {
          url: urls.passwordResetSubmit,
          method: 'POST',
          data: values,
        };
      },
    }),
  }),
});

export const {
  useValidateTokenMutation,
  useSaveExternMutation,
  useResetPasswordMutation,
  useResetPasswordSubmitMutation,
} = passwordResetApi;
